"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessorBaseNode = void 0;
const BaseNode_1 = require("../BaseNode");
/**
 * The AccessorBaseNode is used to pull data from an accessor and return it in the output
 * The type of output is determined by the schema provided
 */
class AccessorBaseNode extends BaseNode_1.BaseNode {
    constructor(accessorName, schemaId, 
    // required options for running the transform node
    init, 
    // options only needed for design time
    design) {
        super(init, design);
        this._resolve = () => {
            const accessorName = this.accessorName;
            if (this.accessorMap && this.accessorMap[accessorName]) {
                return this.accessorMap[accessorName]();
            }
            else {
                //console.error(`Could not find accessor: ${accessorName}`);
            }
        };
        this.accessorName = accessorName;
        this.schemaId = schemaId;
    }
    get interfaceDefinition() {
        return {
            InputParams: {},
            ConfigParams: {},
            OutputParams: this.schemaLookup.getSchema(this.schemaId),
        };
    }
}
exports.AccessorBaseNode = AccessorBaseNode;
//# sourceMappingURL=AccessorBaseNode.js.map